<template>
  <div class="delete-account-success">
    <sprite id="app/added" class="status-modal__icon" />
    <h3 class="delete-account-success__headline">
      {{ $t("headline") }}
    </h3>
    <p class="delete-account-success__text">
      {{ $t("text") }}
    </p>
    <a class="delete-account-success__cta button" :href="$options.rootPath">
      {{ $t("cta") }}
    </a>
  </div>
</template>

<script>
import Sprite from "@/shared/sprite"
import "/wds/sprites/app/added.svg"
import globals from "@/utils/globals"

export default {
  name: "DeleteAccountSuccess",
  rootPath: globals.routes.root,
  components: {
    Sprite
  },
  i18n: {
    messages: {
      en: {
        headline: "Account successfully deleted",
        text: "We deleted all data associated with your account.",
        cta: "Dismiss"
      },
      de: {
        headline: "Account erfolgreich gelöscht",
        text: "Dein Account einschließlich der personenbezogenen Daten wurde gelöscht.",
        cta: "Schließen"
      }
    }
  }
}
</script>

<style lang="scss">
.delete-account-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: $x-wide-block-width;
  padding: $spacing-48 $spacing-24 $spacing-24;

  text-align: center;

  &__headline {
    @include font-style(h3);

    width: 100vw;
    max-width: 100%;
    margin-bottom: $spacing-24;
  }

  &__text {
    @include font-style(p);

    margin-bottom: $spacing-24;
  }
}
</style>
